import { BootStage } from "./types";

export const ALL_BOOT_STAGES: BootStage[] = [
	"microkernel",
	"kernel",
	"pre-authentication",
	"authentication",
	"appd-retrieval",
	"system-preuser",
	"preuser",
	"preuser2",
	"preuser3",
	"preuser4",
	"system-earlyuser",
	"earlyuser",
	"user",
];
export const CRITICAL_BOOT_STAGES: BootStage[] = ["microkernel", "kernel"];

export const SYSLOG_CHANNEL = "systemManager.systemlog";
export const SHOW_SYSLOG_CHANNEL = "systemManager.showSystemlog";
export const HIDE_SYSLOG_CHANNEL = "systemManager.hideSystemlog";
export const STATUS_CHANNEL_BASE = "systemManager.boot.status";
export const STAGE_CHANNEL = "systemManager.boot.stage";
export const CHECKPOINT_CHANNEL_BASE = "systemManager.checkpoint";
